





























































































































































































































import {
  Component, Prop, Mixins,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import ToolMixin from '@/mixins/Tool.vue';
import utils from '@/services/utils';
import GeneralModule from '@/store/modules/General';
import BankAccountModule from '@/store/modules/BankAccount';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {

  },
})

export default class MemberBody extends Mixins(
  ErrorHandleMixin, ToolMixin,
) {
  GeneralInstance = getModule(GeneralModule, this.$store);

  BankAccountInstance = getModule(BankAccountModule, this.$store);

  @Prop() readonly data: any;

  @Prop() readonly footer: any;

  @Prop() readonly fetchWinloseAgent!: Function;

  @Prop() readonly paginationDetail!: object;

  @Prop() readonly mainRole!: string;

  utilsInstance = utils;

  handleSub(username, role, source) {
    this.fetchWinloseAgent(username, role, source);
  }
}
